import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';

import type { ResponseError } from '../../types';

export const initialState = {
    loading: false,
    error: <ResponseError | null>null,
};

const ssoSlice = createSlice({
    name: 'sso',
    initialState,
    reducers: {
        setLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.loading = payload;
        },
        setError: (state, { payload }: PayloadAction<ResponseError | null>) => {
            state.error = payload;
        },
    },
});

const ssoLogin = createAction('auth/ssoLogin', (domain: string) => ({
    payload: { domain },
}));

export default ssoSlice.reducer;

const { setLoading, setError } = ssoSlice.actions;

export const ssoActions = {
    setLoading,
    setError,
    ssoLogin,
};
